export enum NavigationPath {
  LOGIN = '/login',
  REGISTRATION = '/registration',
  FORGET_PASSWORD = '/reset-password',
  HOME = '/home',
  MY_PORTFOLIO = '/my-portfolio',
  PORTFOLIO = '/portfolio',
  INVEST = '/invest',
  MY_CELLAR = '/my-cellar',
  DISCOVER = '/discover',
  ACCOUNTS = '/accounts',
  TERMS_AND_CONDITIONS = '/legal/terms-and-conditions',
  PRIVACY_POLICY = '/legal/privacy-policy',
  PAYMENT_CONFIRMATION = '/payment-confirmation',
  NOTIFICATIONS = '/notifications',
  CONTACT_US = '/contact_us',
  CHECKOUT_SUCCESS = '/checkout_success',
  CHECKOUT_FAIL = '/checkout_fail',
  PROFORMAREPORT = '/proforma_report',
  TRADE = '/trade',
  PORTFOLIO_CHAT = '/portfolio-chat',

  ACCOUNTS_SETTINGS = '/accounts/settings',
  ACCOUNTS_SETTINGS_AUTO_TRADE = '/accounts/settings/auto-trade',
  ACCOUNTS_OVERVIEW = '/accounts/overview',
  ACCOUNTS_PROFILE = '/accounts/profile',
  ACCOUNTS_PAYMENTS = '/accounts/payments',
  ACCOUNTS_HELP_CENTER = '/accounts/Help-center',
}

export interface AddressType {
  id?: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  isDefault?: boolean;
}

export interface PortfolioBalance {
  balance?: number;
  portfolioName: string;
  portfolioId: string;
  currentHoldings: number;
  capitalInvested: number;
  totalMgmtFee: number;
  netProceedsFromSales: number;
  // netPosition: number;
  netPositionPct: number;
  profitAndLoss: number;
  profitAndLossPct: number;
  balancePending: number;
  totalRefunds: number;
  netContributions: number;
  currentFeeModel?: boolean;
  feeModel?: string;
  firstDealDate?: string;
  inFlow: number;
  netPosition: number;
  outFlow: number;
  valuation: number;
  transfersIn?: number;
  transfersOut?: number;
  paidIn?: number;
  broking?: number;
  refund?: number;
  accountHolderId?: number;
}

export enum PortfolioBalanceInfo {
  CURRENT_HOLDINGS_TEXT = 'portfolio:summary.texts.currentHoldings',
  CAPITAL_INVESTED_TEXT = 'portfolio:summary.texts.currentInvested',
  NET_PROCEEDS_FROM_SALES_TEXT = 'portfolio:summary.texts.netProceedsFromSales',
  AVAILABLE_BALANCE = 'portfolio:summary.texts.availableBalance',
  // NET_POSITION_TEXT = 'portfolio:summary.texts.netPosition',
  PORTFOLIO_VALUATION_TEXT = 'portfolio:summary.texts.portfolioValuation',
  BALANCE_PENDING_TEXT = 'portfolio:summary.texts.balancePending',
  TOTAL_REFUNDS_TEXT = 'portfolio:summary.texts.totalRefunds',
  NET_CONTRIBUTIONS_TEXT = 'portfolio:summary.texts.netContributions',

  CURRENT_ASSETS_TEXT = 'portfolio:summary.texts.currentAssets',
  INFLOWS_TEXT = 'portfolio:summary.texts.inflows',
  OUTFLOWS_TEXT = 'portfolio:summary.texts.outflows',
  NET_POSITION_TEXT = 'portfolio:summary.texts.netPosition',
}

export interface ChartDataPoint {
  x: number;
  y: number;
  data?: Record<string, unknown>;
}

export type Size = {
  width?: number;
  height?: number;
};

export enum SortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export interface UserProfile {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  dateOfBirth: string | null;
  addressline1?: string;
  addressline2?: string;
  addressline3?: string;
  city?: string;
  country?: string;
  postCode?: string;
  state?: string;
}

export enum Alignment {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export enum RefreshRegion {
  HEADER = 'header',
}
